import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=faea0fe4&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faea0fe4",
  null
  
)

export default component.exports